export default __webpack_public_path__ + "static/media/icon.bed17f63.png";